import { Fragment } from 'react'
import {
  Box,
  Button,
  Heading,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

const CertificatePreview = ({
  isOpen,
  onClose,
  fileURL,
  enrollment,
  fetchedData,
  formRef
}) => {
  const formValues = formRef?.current?.values
  return (
    <Modal size={'full'} onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent bg="transparent" boxShadow="none">
        <ModalHeader>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody display="flex" justifyContent="center" alignItems="center">
          <Box position="relative" width="100%" maxW="1000px">
            <Image src="/assets/images/dummy.png" width="100%" height="auto" />
            <Heading
              position="absolute"
              left="50%"
              top="39%"
              transform="translate(-50%, -50%)"
              fontSize={{
                base: '18px',
                sm: '22px',
                md: '32px',
                lg: '45px',
              }}
              textAlign="center"
              fontFamily={'"Dancing Script", cursive'}
            >
              {formValues?.name || fetchedData?.name}
            </Heading>
            <Text
              position="absolute"
              left="50%"
              top="45%"
              transform="translate(-50%, -50%)"
              fontSize={{
                base: '10px',
                sm: '12px',
                md: '14px',
                lg: '16px',
              }}
              textAlign="center"
            >
              Enrollment No. {enrollment}
            </Text>
            <Image
              position="absolute"
              right="15%"
              top="40%"
              transform="translate(50%, -50%)"
              src={fileURL}
              borderRadius="5px"
              width={{
                base: '50px',
                sm: '70px',
                md: '100px',
                lg: '130px',
              }}
              height={{
                base: '50px',
                sm: '70px',
                md: '100px',
                lg: '130px',
              }}
              objectFit="cover"
            />
          </Box>
        </ModalBody>

        <ModalFooter justifyContent="center">
          <Button onClick={onClose}>Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default CertificatePreview
